(function () {
  window.__ddHeroVideoRev = 11;
  /* hero-video-autoplay-v3 — prime muted inline loops; hide native chrome via dd-hero.css */
  var hero = document.querySelector('[data-dd-hero]');
  if (!hero) return;

  var isDesignMode = window.Shopify && window.Shopify.designMode;
  var slides = hero.querySelectorAll('.dd-hero__slide');

  /* Video background handling — runs for ANY hero that has a video,
     including single-slide heroes that take the early-return below.
     A slide can carry a <video class="dd-hero__video"> instead of an
     <img>. The slide swap toggles is-active/opacity but doesn't pause
     the video, so without this all videos play simultaneously (CPU +
     bandwidth waste). We pause non-active videos and rewind the
     active-slide video to t=0 on swap so each rotation looks fresh.

     Deliberately NO prefers-reduced-motion gate here: devices report
     "reduce" without the owner knowing (Android battery savers, iOS
     accessibility sync), and gating playback on it made the hero look
     broken (frozen poster) far more often than it helped. Merchant
     decision 2026-07-21: the background video always plays. */

  function primeHeroVideo(v) {
    if (window.ddPrimeInlineVideo) window.ddPrimeInlineVideo(v);
    else {
      v.muted = true;
      v.defaultMuted = true;
      v.playsInline = true;
      v.controls = false;
      v.removeAttribute('controls');
    }
    v.setAttribute('tabindex', '-1');
    if (!v.__ddHeroVideoBound) {
      v.__ddHeroVideoBound = true;
      v.addEventListener('playing', function () {
        v.classList.add('is--playing');
        try {
          v.removeAttribute('poster');
        } catch (_) {}
      });
    }
  }

  function playHeroVideo(v, restart) {
    primeHeroVideo(v);
    if (window.ddPlayInlineVideo) {
      window.ddPlayInlineVideo(v, { restart: !!restart, layoutFrames: 0 });
      return;
    }
    if (restart) {
      try {
        v.currentTime = 0;
      } catch (_) {}
    }
    var p = v.play();
    if (p && typeof p.catch === 'function') p.catch(function () {});
  }

  function syncVideoPlayback(opts) {
    opts = opts || {};
    var restart = !!opts.restart;
    var videos = hero.querySelectorAll('.dd-hero__video');
    if (!videos.length) return;
    for (var i = 0; i < videos.length; i++) {
      var v = videos[i];
      primeHeroVideo(v);
      var slide = v.closest('.dd-hero__slide');
      var isActiveVid = slide && slide.classList.contains('is-active');
      try {
        if (isActiveVid) {
          playHeroVideo(v, restart);
        } else {
          v.pause();
          v.classList.remove('is--playing');
        }
      } catch (_) { /* defensive: never let a video error break the slideshow */ }
    }
  }

  syncVideoPlayback({ restart: false });

  /* Mobile Chrome/WebKit often reject the first play() when the hero was
     off-screen at parse time or the tab was backgrounded. Re-kick when the
     hero intersects the viewport and when the page is restored. */
  if (typeof IntersectionObserver !== 'undefined') {
    var heroVisIo = new IntersectionObserver(function (entries) {
      if (entries[0] && entries[0].isIntersecting) syncVideoPlayback({ restart: false });
    }, { threshold: 0.05 });
    heroVisIo.observe(hero);
  }
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') syncVideoPlayback({ restart: false });
  });
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) syncVideoPlayback({ restart: false });
  });
  window.addEventListener('load', function () {
    syncVideoPlayback({ restart: false });
  });

  if (slides.length <= 1) {
    window.__ddHeroAutoplay = {
      holds: {},
      setHeld: function (key, held) {
        this.holds[key] = !!held;
      }
    };
    return;
  }

  var sectionRoot = hero.closest('.shopify-section') || hero.parentElement;
  var dotsContainer = sectionRoot && sectionRoot.querySelector('[data-hero-dots]');
  /* Portal dots to the END of #MainContent on the homepage pin scroll.
     They already sit outside `.dd-hero`, but inside the hero
     shopify-section wrapper they can't take clicks while any later
     section box overlaps them. As a last child of MainContent at
     z-index: 0 they paint above the fixed hero (same z, later DOM
     order) yet BELOW the z-index: 1 category slab — so the slab covers
     them on scroll and captures clicks exactly where it visually
     covers, while the exposed dots stay clickable. Skip in design mode
     (section re-injection) and reduced-motion (hero stays in-flow). */
  var portalTarget = document.getElementById('MainContent');
  if (
    dotsContainer &&
    portalTarget &&
    !isDesignMode &&
    document.body.classList.contains('template-index') &&
    !window.matchMedia('(prefers-reduced-motion: reduce)').matches
  ) {
    portalTarget.appendChild(dotsContainer);
    dotsContainer.classList.add('dd-hero__dots--portaled');
  }
  var dots = dotsContainer
    ? dotsContainer.querySelectorAll('.dd-hero__dot')
    : hero.querySelectorAll('.dd-hero__dot');
  var activeIndex = 0;
  var total = slides.length;
  var autoplayTimer = null;

  function restartProgress(dot) {
    if (!dot) return;
    var fill = dot.querySelector('.dd-hero__dot-fill');
    if (!fill) return;
    // Clone-and-replace to force the CSS animation to restart from 0 cleanly.
    var clone = fill.cloneNode(true);
    fill.parentNode.replaceChild(clone, fill);
  }

  function goTo(idx) {
    slides[activeIndex].classList.remove('is-active');
    slides[activeIndex].setAttribute('aria-hidden', 'true');
    if (dots[activeIndex]) {
      dots[activeIndex].classList.remove('is--active');
      dots[activeIndex].setAttribute('aria-selected', 'false');
    }
    activeIndex = ((idx % total) + total) % total;
    slides[activeIndex].classList.add('is-active');
    slides[activeIndex].setAttribute('aria-hidden', 'false');
    if (dots[activeIndex]) {
      dots[activeIndex].classList.add('is--active');
      dots[activeIndex].setAttribute('aria-selected', 'true');
      restartProgress(dots[activeIndex]);
    }
    syncVideoPlayback({ restart: true });
  }

  dots.forEach(function (dot) {
    dot.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var idx = parseInt(dot.getAttribute('data-dot-index'), 10);
      if (isNaN(idx)) idx = Array.prototype.indexOf.call(dots, dot);
      goTo(idx);
      resetAutoplay();
    });
  });

  if (dotsContainer) {
    dotsContainer.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
      e.preventDefault();
      goTo(activeIndex + (e.key === 'ArrowRight' ? 1 : -1));
      resetAutoplay();
      if (dots[activeIndex]) dots[activeIndex].focus();
    });
  }

  var autoplayEnabled = hero.getAttribute('data-autoplay') === 'true' && !isDesignMode;
  var speed = (parseInt(hero.getAttribute('data-speed'), 10) || 5) * 1000;

  function isAutoplayHeld() {
    var holds = window.__ddHeroAutoplay && window.__ddHeroAutoplay.holds;
    if (!holds) return false;
    for (var key in holds) {
      if (holds[key]) return true;
    }
    return false;
  }

  function applyAutoplayHold() {
    if (!autoplayEnabled) return;
    if (isAutoplayHeld()) {
      stopAutoplay();
      hero.classList.add('is--autoplay-paused');
      return;
    }
    hero.classList.remove('is--autoplay-paused');
    if (dots[activeIndex]) restartProgress(dots[activeIndex]);
    startAutoplay();
  }

  function startAutoplay() {
    if (!autoplayEnabled || isAutoplayHeld()) return;
    stopAutoplay();
    autoplayTimer = setInterval(function () { goTo(activeIndex + 1); }, speed);
  }

  function stopAutoplay() {
    if (autoplayTimer) { clearInterval(autoplayTimer); autoplayTimer = null; }
  }

  function resetAutoplay() {
    stopAutoplay();
    if (isAutoplayHeld()) {
      hero.classList.add('is--autoplay-paused');
      return;
    }
    hero.classList.remove('is--autoplay-paused');
    if (dots[activeIndex]) restartProgress(dots[activeIndex]);
    startAutoplay();
  }

  window.__ddHeroAutoplay = {
    holds: {},
    setHeld: function (key, held) {
      this.holds[key] = !!held;
      applyAutoplayHold();
    }
  };

  startAutoplay();

  var touchStartX = 0;
  var touchMoved = false;

  hero.addEventListener('touchstart', function (e) {
    touchStartX = e.changedTouches[0].clientX;
    touchMoved = false;
  }, { passive: true });

  hero.addEventListener('touchmove', function (e) {
    if (!touchMoved && Math.abs(e.changedTouches[0].clientX - touchStartX) > 30) {
      touchMoved = true;
    }
  }, { passive: true });

  hero.addEventListener('touchend', function (e) {
    if (!touchMoved) return;
    var diff = e.changedTouches[0].clientX - touchStartX;
    if (diff > 30) { goTo(activeIndex - 1); }
    else if (diff < -30) { goTo(activeIndex + 1); }
    resetAutoplay();
  }, { passive: true });

  /* NOTE: the image-scroll parallax that used to live here has been
     removed. It was running a second independent rAF pipeline on top of
     the hero-pin scroll-off in dd-homepage-scroll.js — each frame wrote
     `transform` to a different element (img vs .dd-hero), their ticking
     flags were separate, and the compound transforms drifted by a frame
     causing the "crunchy/jittery" feel. The pin in dd-homepage-scroll.js
     is the single source of truth for hero scroll motion now. */

  /* Trust-panel baseline sync.
     ---------------------------
     The hero content is centered + biased down 6vh, so its bottom
     edge sits at a content-height-dependent Y inside the hero. The
     trust-stat panel (right side) is requested to BOTTOM-ALIGN with
     that content bottom — but the content's bottom offset isn't a
     fixed pixel value (it depends on what copy the merchant typed:
     eyebrow / heading / subtitle / CTA presence and length).

     Pure-CSS bottom-alignment of two siblings with different
     intrinsic heights and different layout schemes isn't possible
     without anchor positioning (Safari 26 has it, Firefox doesn't).
     Cheapest robust fix: measure content's bottom-from-hero-bottom
     and write it to a CSS var that the trust panel reads.

     Re-runs when the active slide changes (different copy per slide
     means different content heights), on resize, on font-load
     (DieGroteskB tightens line-heights once it lands), and via a
     ResizeObserver on the content (handles theme-editor live edits
     and any reflow we don't anticipate). */
  var heroEl = hero;
  var trustPanel = heroEl.querySelector('.dd-hero-trust__panel');

  function syncTrustBottom() {
    if (!trustPanel) return;
    var activeSlide = heroEl.querySelector('.dd-hero__slide.is-active');
    var content = activeSlide && activeSlide.querySelector('.dd-hero__content');
    if (!content) return;

    /* Measure the LAST VISIBLE CHILD of .dd-hero__content (typically
       the CTA, falling back to subtitle / heading / eyebrow when the
       merchant doesn't render a CTA on a given slide), NOT the
       content container itself. The container has padding-bottom of
       clamp(2.8rem, 5vw, 6.4rem) on desktop — measuring its rect
       includes that invisible padding strip and pushes the trust
       panel ~5-6rem below the actual CTA baseline.

       lastElementChild walks back from the end so it finds the last
       element regardless of how many of {eyebrow, heading, subtitle,
       CTA} are present. */
    var anchor = content.lastElementChild;
    if (!anchor) return;

    var heroRect = heroEl.getBoundingClientRect();
    var anchorRect = anchor.getBoundingClientRect();
    var bottomFromHeroBottom = Math.round(heroRect.bottom - anchorRect.bottom);
    /* Clamp at 0 so a degenerate measurement (anchor somehow below
       the hero) doesn't push the panel off-screen. */
    if (bottomFromHeroBottom < 0) bottomFromHeroBottom = 0;
    heroEl.style.setProperty('--dd-hero-trust-bottom', bottomFromHeroBottom + 'px');
    /* Reveal the panel once it's positioned correctly. CSS hides it
       (opacity: 0) on first paint to avoid a layout-shift flash. */
    trustPanel.classList.add('is-baseline-synced');
  }

  if (trustPanel) {
    /* First measurement after layout settles. rAF-then-rAF gives the
       slide flex layout a frame to resolve before we read. */
    requestAnimationFrame(function () { requestAnimationFrame(syncTrustBottom); });

    /* Safety net: if first measurement somehow fails (no active
       slide, no content, JS error), reveal the panel anyway after
       500ms with the CSS fallback bottom so users still see the
       stats. Better to show them slightly mis-aligned than to hide
       them indefinitely. The class-add is idempotent so this is a
       no-op when measurement succeeded. */
    setTimeout(function () {
      if (trustPanel) trustPanel.classList.add('is-baseline-synced');
    }, 500);

    window.addEventListener('resize', syncTrustBottom);

    /* Observe content size changes — fonts loading, theme editor
       edits, slide-change content swaps. attributeFilter:['class'] on
       .dd-hero__slide isn't enough on its own: when goTo() flips
       is-active, the new active slide's content has a different
       intrinsic height, so we need geometry-level observation too. */
    if (typeof ResizeObserver !== 'undefined') {
      var ro = new ResizeObserver(syncTrustBottom);
      slides.forEach(function (slide) {
        var c = slide.querySelector('.dd-hero__content');
        if (c) ro.observe(c);
      });
    }

    /* document.fonts.ready lets DieGroteskB drop in before we
       measure — heading line-height shifts noticeably between
       fallback and the loaded face. */
    if (document.fonts && document.fonts.ready && typeof document.fonts.ready.then === 'function') {
      document.fonts.ready.then(syncTrustBottom);
    }

    /* Slide change → re-sync. Watch each slide's `class` attribute
       for the is-active flip rather than monkey-patching goTo —
       decoupled from the carousel's internal mechanics. */
    if (typeof MutationObserver !== 'undefined') {
      var slideMo = new MutationObserver(function () {
        requestAnimationFrame(syncTrustBottom);
      });
      slides.forEach(function (slide) {
        slideMo.observe(slide, { attributes: true, attributeFilter: ['class'] });
      });
    }
  }
})();

(function initHeroSplitCta() {
  var heroRoot = document.querySelector('[data-dd-hero]');
  if (!heroRoot) return;

  var roots = heroRoot.querySelectorAll('[data-dd-hero-split-cta]');
  if (!roots.length) return;

  var slides = heroRoot.querySelectorAll('.dd-hero__slide');
  var canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var openRoot = null;

  function syncSplitCtaAutoplay() {
    var api = window.__ddHeroAutoplay;
    if (!api || typeof api.setHeld !== 'function') return;

    var shouldHold = false;
    for (var i = 0; i < roots.length; i++) {
      if (roots[i].classList.contains('is--open') || roots[i].__ddSplitCtaHover) {
        shouldHold = true;
        break;
      }
    }
    api.setHeld('splitCta', shouldHold);
  }

  function setOpen(root, open) {
    if (!root) return;
    var trigger = root.querySelector('.dd-hero-split-cta__trigger');
    if (!trigger) return;

    if (open) {
      if (openRoot && openRoot !== root) setOpen(openRoot, false);
      openRoot = root;
      root.classList.add('is--open');
      trigger.setAttribute('aria-expanded', 'true');
    } else {
      if (openRoot === root) openRoot = null;
      root.classList.remove('is--open');
      trigger.setAttribute('aria-expanded', 'false');
    }

    syncSplitCtaAutoplay();
  }

  function closeAll() {
    for (var i = 0; i < roots.length; i++) setOpen(roots[i], false);
  }

  for (var r = 0; r < roots.length; r++) {
    (function (root) {
      var trigger = root.querySelector('.dd-hero-split-cta__trigger');
      if (!trigger) return;

      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        setOpen(root, !root.classList.contains('is--open'));
      });

      if (canHover) {
        var hoverTarget = root.querySelector('.dd-hero-split-cta__box') || root;
        hoverTarget.addEventListener('mouseenter', function () {
          root.__ddSplitCtaHover = true;
          syncSplitCtaAutoplay();
          setOpen(root, true);
        });
        hoverTarget.addEventListener('mouseleave', function () {
          root.__ddSplitCtaHover = false;
          setOpen(root, false);
        });
      }
    })(roots[r]);
  }

  document.addEventListener('click', function (e) {
    if (!openRoot || openRoot.contains(e.target)) return;
    setOpen(openRoot, false);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAll();
  });

  if (typeof MutationObserver !== 'undefined' && slides.length) {
    var splitMo = new MutationObserver(function (mutations) {
      for (var m = 0; m < mutations.length; m++) {
        var slide = mutations[m].target;
        if (!slide.classList || slide.classList.contains('is-active')) continue;
        var split = slide.querySelector('[data-dd-hero-split-cta]');
        if (split) setOpen(split, false);
      }
    });
    for (var s = 0; s < slides.length; s++) {
      splitMo.observe(slides[s], { attributes: true, attributeFilter: ['class'] });
    }
  }
})();
